import script from "./MenuNav.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuNav.vue?vue&type=script&setup=true&lang=js"

import "./MenuNav.vue?vue&type=style&index=0&id=e71fb62a&scoped=true&lang=css"

import exportComponent from "/Users/aakash/Documents/projects/portfoilio-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e71fb62a"]])

export default __exports__